import React from 'react'

const CaddieLoading = () => {
	return <div></div>
}

export default CaddieLoading
